import gql from 'graphql-tag';
import { useState, useContext, useEffect } from 'react';
import { AccountContext } from '../components/AccountContext';
import { useQuery } from '@apollo/react-hooks';
import { isAccountOfNewBusinessModelType } from '../utils/AppUtil';

const CHECK_ACCOUNT_TYPE_QUERY = gql`
  query checkAccountTypeQuery($accountId: ID!) {
    account(id: $accountId) {
      id
      type
    }
  }
`;

const DEFAULT_ACCOUNT_STATE = {
  id: null,
  type: null,
};

const useNewBusinessModelAccountCheck = () => {
  const [account, setAccount] = useState(DEFAULT_ACCOUNT_STATE);

  const currentAccount = useContext(AccountContext);

  const { data } = useQuery(CHECK_ACCOUNT_TYPE_QUERY, { variables: { accountId: currentAccount } });

  const { account: accountFromQuery } = data;

  useEffect(() => {
    if (accountFromQuery) {
      setAccount(accountFromQuery);
    }
  }, [currentAccount, accountFromQuery]);

  const { type } = account;

  const isNewBusinessModelAccount = isAccountOfNewBusinessModelType(type);

  return {
    isNewBusinessModelAccount,
  };
};

export default useNewBusinessModelAccountCheck;
